// extracted by mini-css-extract-plugin
export default {"container":"Detail_container__SZVwf","tarjetas":"Detail_tarjetas__uBVtT","h1prop":"Detail_h1prop__dfzJd","contImg":"Detail_contImg__Qy-a6","imagen":"Detail_imagen__qBvBS"};